module.exports = __webpack_public_path__ + "6256cad206f71c76a76fcacfcc53f1c7.svg";